module.exports = __webpack_public_path__ + "static/media/L-2.36e8a1eb.svg";